import { onMounted, ref, type Ref } from 'vue'
import type { EmblaCarouselType } from 'embla-carousel'

export default function useEmblaProgress(emblaApi: Ref) {
    const progress = ref(0)

    function applyProgress(emblaApi: EmblaCarouselType) {
        progress.value = Math.max(
            0,
            Math.min(100, emblaApi.scrollProgress() * 100)
        )
    }

    onMounted(() => {
        if (!emblaApi.value) {
            return
        }

        ;(emblaApi.value as EmblaCarouselType)
            .on('init', applyProgress)
            .on('reInit', applyProgress)
            .on('scroll', applyProgress)
            .on('slideFocus', applyProgress)
    })

    return progress
}
